import {formatString} from '@optimaxdev/utils';

export const CART_UPGRADE_SAME_FRAME_USAGE = {
    action: 'Product Upgrades',
    category: formatString('Cart - {{version}}'),
    label: formatString('Same frame as Sunglasses - {{action}}'),
    name: 'Cart',
};

export const CART_UPGRADE_UPGRADES_USAGE = {
    action: 'Product Upgrades',
    category: formatString('Cart - {{version}}'),
    label: formatString('{{label}} - {{action}}'),
    name: 'Cart',
};

export const CART_UPGRADE_UPGRADES_LEARN_MORE = {
    action: 'Product Upgrades',
    category: formatString('Cart - {{version}}'),
    label: formatString('Learn More - {{label}}'),
    name: 'Cart',
};

export const CART_UPGRADE_UPGRADE_INSURANCE_LEARN_MORE_USAGE = {
    action: 'Product Upgrades',
    category: formatString('Cart - {{version}}'),
    label: formatString('One year insurance - {{action}} - PopUp {{place}}'),
    name: 'Cart',
};

export const CART_UPGRADE_CLOSE_ACCESSORY_NOTIFICATION = {
    action: formatString('Accessories Notification - {{notificationType}}'),
    category: formatString('Cart - {{version}}'),
    label: 'Close',
    name: 'Cart',
};

export const CART_UPGRADE_RECENTLY_VIEW_OR_ADD = {
    action: 'Second Frame Offer',
    category: formatString('Cart - {{version}}'),
    label: formatString('{{label}}'),
    name: 'Cart',
};

export const CART_UPGRADE_UPGRADE_INSURANCE_LEARN_MORE_USAGE_MODAL = {
    action: 'Product Upgrades',
    category: formatString('Cart - {{version}}'),
    label: formatString('{{label}}'),
    name: 'Cart',
};

export const CART_UPGRADE_UPGRADES_LEARN_MORE_POPUP_USAGE = {
    action: 'Product Upgrades',
    category: formatString('Cart - {{version}}'),
    label: formatString('{{label}} - {{action}} - PopUp'),
    name: 'Cart',
};

export const CART_UPGRADE_NAVIGATION = {
    action: 'Navigation',
    category: formatString('Cart - {{version}}'),
    label: formatString('{{label}}'),
    name: 'Cart',
};

export const CART_UPGRADE_PRESCRIPTION = {
    action: 'Product Details',
    category: formatString('Cart - {{version}}'),
    label: formatString('Prescription - {{label}}'),
    name: 'Cart',
};

export const CART_UPGRADE_EDIT = {
    action: 'Product Details',
    category: formatString('Cart - {{version}}'),
    label: 'Edit',
    name: 'Cart',
};
